import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const PageHero = ({ image, imageAlt, imageTestid, eyebrow, title, children }) => (
  <section className="relative overflow-hidden">
    <motion.img
      src={image}
      alt={imageAlt}
      data-testid={imageTestid}
      initial={{ scale: 1.08, opacity: 0.5 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 1.2, ease: EASE }}
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0b0d10] via-[#0b0d10]/85 to-[#0b0d10]/30" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0b0d10] via-transparent to-[#0b0d10]/70" />
    <div className="relative mx-auto max-w-6xl px-4 py-20">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: EASE }}
        className="mb-2 text-sm font-semibold uppercase tracking-[0.25em] text-primary"
      >
        {eyebrow}
      </motion.p>
      <h1 className="max-w-3xl font-display text-4xl font-bold uppercase leading-tight sm:text-5xl">
        <span className="block overflow-hidden pb-1">
          <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
          >
            {title}
          </motion.span>
        </span>
      </h1>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.35, ease: EASE }}
        className="mt-6 max-w-2xl text-muted-foreground md:text-lg"
      >
        {children}
      </motion.div>
    </div>
  </section>
);
